<template>
  <div>
    <form @submit.stop.prevent="form.handleSubmit()">
      <form.Field
        name="name"
        :validators="{
          onBlur: yup.string().required('Name is required')
        }"
      >
        <template #default="{ field }">
          <BaseInput
            v-model="(field.state.value as string)"
            label="Name"
            :name="field.name"
            :error="field.state.meta.errors && field.state.meta.errors[0] as string"
            @blur="field.handleBlur"
            @input="(e) => typeof e === 'string' ? field.handleChange(e) : field.handleChange(e.target.value)"
          />
        </template>
      </form.Field>

      <form.Field name="description" >
        <template #default="{ field }">
          <BaseTextArea
            v-model="(field.state.value as string)"
            label="Description"
            :name="field.name"
            @blur="field.handleBlur"
            @input="(e) => typeof e === 'string' ? field.handleChange(e) : field.handleChange(e.target.value)"
          />
        </template>
      </form.Field>

      <form.Field
        name="hourlyRate"
        :validators="{
          onBlur: yup.string().transform((value) => value.replace(/,/g, '')).test('is-number','Hourly Rate must be a positive number',(value) => !isNaN(Number(value)) && Number(value) > 0).required('Hourly Rate is required')
        }"
      >
        <template #default="{ field }">
          <BaseInputCurrency
            :model-value="(field.state.value as string)"
            :name="field.name"
            label="Hourly Rate"
            :error="(field.state.meta.errors && field.state.meta.errors[0] as string)"
            @blur="field.handleBlur"
            @input="(e) => field.handleChange(e.target.value)"
          />
        </template>
      </form.Field>

      <hr class="mt-6">

      <div class="flex justify-end gap-2 mt-3">
        <form.Subscribe>
          <template #default="{ canSubmit, isSubmitting }">
            <BaseButton
              variant="base"
              text="Cancel"
              :to="{ name: 'ListLabor' }"
              :disabled="isSubmitting"
              :class="{ 'cursor-not-allowed opacity-50': isSubmitting }"
            />

            <BaseButton
              variant="primary"
              text="Save"
              type="submit"
              :disabled="!canSubmit || isSubmitting"
              :class="{ 'cursor-not-allowed opacity-50': !canSubmit || isSubmitting }"
            />
          </template>
        </form.Subscribe>
      </div>
    </form>
  </div>
</template>

<script lang="ts" setup>
import { Labor } from '@/models/labor'
import { PropType, ref } from 'vue'
import BaseInput from '@/components/base/BaseInput.vue'
import BaseInputCurrency from '@/components/base/BaseInputCurrency.vue'
import BaseTextArea from '@/components/base/BaseTextArea.vue'
import BaseButton from '@/components/base/BaseButton.vue'
import { useForm } from '@tanstack/vue-form'
import { yupValidator } from '@tanstack/yup-form-adapter'
import * as yup from 'yup'
import { toNumber } from '@/utils'


const props = defineProps({
  model: {
    type: Object as PropType<Labor>,
    default: () => ({})
  },
  saveFunction: {
    type: Function,
    required: true
  }
})

const labor = ref({ ...props.model, hourlyRate: props.model.hourlyRate?.toString() })

const form = useForm({
  defaultValues: labor.value,
  validatorAdapter: yupValidator(),
  onSubmit: async ({ value }) => {
    const labor = Object.fromEntries(Object.entries(value).filter(([, v]) => v !== undefined))  as unknown as Labor
    labor.hourlyRate = toNumber(labor.hourlyRate)
    await props.saveFunction(labor)
  },
})

</script>
